import React from "react";
import SpecialUnit from "./SpecialUnit";

const CrimeBranch = () => <SpecialUnit speId={1} />;

export default CrimeBranch;
